module.exports = __webpack_public_path__ + "static/3-faa0f8116dfba40242a8d55c68795d2a.jpg";